export default "__VITE_ASSET__Dt$ZvGg1__"